import { REF_STORAGE_KEY, UTM_STORAGE_KEY } from "@/config/site";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
const THIRTY_DAYS = 1000 * 60 * 60 * 24 * 30;

export function captureAdSource() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fresh = {};
    UTM_KEYS.forEach((key) => {
      const value = (params.get(key) || "").trim().slice(0, 200);
      if (value) fresh[key] = value;
    });
    if (Object.keys(fresh).length) {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify({ ...fresh, at: Date.now() }));
      return fresh;
    }
    const stored = JSON.parse(localStorage.getItem(UTM_STORAGE_KEY) || "null");
    if (stored && Date.now() - stored.at < THIRTY_DAYS) {
      const { at, ...rest } = stored;
      return rest;
    }
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.warn("Ad-source capture skipped", error);
  }
  return {};
}

export function captureRefCode() {
  try {
    const param = new URLSearchParams(window.location.search).get("ref");
    if (param && /^[A-Za-z0-9_-]{2,24}$/.test(param)) {
      const code = param.toUpperCase();
      localStorage.setItem(REF_STORAGE_KEY, JSON.stringify({ code, at: Date.now() }));
      return code;
    }
    const stored = JSON.parse(localStorage.getItem(REF_STORAGE_KEY) || "null");
    if (stored && Date.now() - stored.at < THIRTY_DAYS) return stored.code;
  } catch (error) {
    if (process.env.NODE_ENV !== "production") console.warn("Referral capture skipped", error);
  }
  return null;
}
